const init = () => {
  const menuBarButtons = document.querySelectorAll('[data-mega-menu]');
  const megaMenuList = document.querySelectorAll('.js-mega-menu');
  const menu = document.querySelector('.js-menu');

  if (menu === null)
    return;

  if (menuBarButtons.length) {
    menuBarButtons.forEach(btn => {
      btn.addEventListener('click', handleClick);
    })
  }

  document.addEventListener('click', function (e) {
    if (!menu.contains(e.target)) {
      menuBarButtons.forEach(btn => {
        const megaMenuId = btn.dataset.megaMenu;

        megaMenuList.forEach(megaMenu => {
          if (megaMenu.id == `mega-menu-${megaMenuId}`) {
            closeMegaMenu(btn, megaMenu);
          }
        });
      });
    }
  });
};

const handleClick = (e) => {
  const target = e.target;
  const megaMenuId = target.dataset.megaMenu;
  const megaMenuList = document.querySelectorAll('.js-mega-menu');
  const menuBarButtons = document.querySelectorAll('[data-mega-menu]');

  megaMenuList.forEach(megaMenu => {
    if (megaMenu.id == `mega-menu-${megaMenuId}`) {
      if (megaMenu.getAttribute('aria-hidden') == 'false') {
        closeMegaMenu(target, megaMenu);
      } else {
        openMegaMenu(target, megaMenu);
      }
    } else {
      megaMenu.setAttribute('aria-hidden', true);
    }
  });

  menuBarButtons.forEach(btn => {
    if (btn.dataset.megaMenu != megaMenuId) {
      btn.setAttribute('aria-expanded', false);
    }
  })
}

const closeMegaMenu = (target, megaMenu) => {
  megaMenu.setAttribute('aria-hidden', true);
  target.setAttribute('aria-expanded', false);
}

const openMegaMenu = (target, megaMenu) => {
  megaMenu.setAttribute('aria-hidden', false);
  target.setAttribute('aria-expanded', true);
}

const closeMegamenu = {
  init,
};

export default closeMegamenu;
